export const masks = {
  PHONE_INPUT_MASK_RU: '+{7} (000) 000-00-00'
}
